import orderDataReducer from './orderDataReducer';
import ordersDataReducer from './ordersDataReducer';
import linesByOrderIdReducer from './orderLinesByOrderIdReducer';
import relatedDocumentsReducer from './orderDocumentsReducer';
import { combineReducers } from '@reduxjs/toolkit';

const orderDataReducers = combineReducers({
	orders: ordersDataReducer,
	singleOrder: orderDataReducer,
	linesByOrderId: linesByOrderIdReducer,
	relatedDocuments: relatedDocumentsReducer
});

export default orderDataReducers;